import { PainCondition } from './imageDxTypes';

// Used for both canine and equine pain diagnosis.
export const orthopedicOa: PainCondition = {
  label: 'Orthopedic: OA',
  value: 'orthopedic_oa'
};

export const orthopedicOther: PainCondition = {
  label: 'Orthopedic: Other',
  value: 'orthopedic_other'
};

// Used for canine pain diagnosis.
export const luxatingPatellas: PainCondition = {
  label: 'Luxating patellas',
  value: 'luxating_patellas'
};

export const degenerativeDiscDisease: PainCondition = {
  label: 'Degenerative disc disease',
  value: 'degenerative_disc_disease'
};

export const intraAbdominalPathology: PainCondition = {
  label: 'Intra-abdominal pathology',
  value: 'intra_abdominal_pathology'
};

export const trauma: PainCondition = {
  label: 'Trauma',
  value: 'trauma'
};

export const pawOrNailInjury: PainCondition = {
  label: 'Paw or nail injury',
  value: 'paw_or_nail_injury'
};

export const cancer: PainCondition = {
  label: 'Cancer',
  value: 'cancer'
};

export const myofascialPain: PainCondition = {
  label: 'Myofascial pain',
  value: 'myofascial_pain'
};

export const cruciateLigamentInjury: PainCondition = {
  label: 'Cruciate Ligament Injury',
  value: 'cruciate_ligament_injury'
};

// Used for equine pain diagnosis.
export const navicular: PainCondition = {
  label: 'Navicular',
  value: 'navicular'
};

export const tendinopathy: PainCondition = {
  label: 'Tendinopathy',
  value: 'tendinopathy'
};

export const neurological: PainCondition = {
  label: 'Neurological',
  value: 'neurological'
};

export const sacroiliacDisease: PainCondition = {
  label: 'Sacroiliac Disease',
  value: 'sacroiliac_disease'
};

export const odsp: PainCondition = {
  label: 'Overriding Dorsal Spinous Process',
  value: 'odsp'
};

// Used for feline pain diagnosis.
export const muscleInjury: PainCondition = {
  label: 'Muscle/Soft Tissue Injury',
  value: 'muscle_injury'
};

export const hipDysplasia: PainCondition = {
  label: 'Hip Dysplasia',
  value: 'hip_dysplasia'
};

export const luxation: PainCondition = {
  label: 'Luxation',
  value: 'luxation'
};

export const patellarLuxation: PainCondition = {
  label: 'Patellar Luxation',
  value: 'patellar_luxation'
};

export const meniscalInjury: PainCondition = {
  label: 'Meniscal Injury',
  value: 'meniscal_injury'
};
